<template>
  <!-- <div
    class="c-header -flex u-bg-blue"
    :style="{
      'background-image':
        'url(' + require('@arag/assets/img/slider/slider_betterdoc.svg') + ')',
    }"
  >
    <div class="c-header__content">
      <img src="@arag/assets/img/betterdoc_logo.svg" />
      <div class="c-header__text">
        Ihr exklusiver Zugang zu den besten Ärzten.
      </div>
    </div>
    <div class="c-header__image">
      <img src="@/assets/img/slider/betterdoc.svg" />
    </div>
  </div> -->
  <!-- <div
    class="c-header u-bg-blue -contain"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/header/icon_betterdoc.svg') + ')',
    }"
  >
    <img
      class="c-header__logo"
      src="@arag/assets/img/betterdoc_logo.svg"
      width="80"
    />
  </div> -->
  <Header
    class="u-bg-blue -contain"
    headline="Exklusiver und schneller Zugang zu den besten Ärzten."
    :image="require('@/assets/img/header/icon_betterdoc.svg')"
    :logo="require('@arag/assets/img/betterdoc_logo.svg')"
    logoWidth="80"
    @openChat="$emit('open-chat')"
    :hideButton="from === 'chat'"
  />
  <p class="ion-padding-top">
    <b
      >BetterDoc findet den passenden Spezialisten für Ihre gesundheitliche
      Situation.</b
    >
  </p>
  <p>
    Egal, ob Sie einen neuen Arzt suchen oder schon in Behandlung sind: Mit der
    Hilfe von BetterDoc kommen Sie schnell zum bestmöglichen Behandler.
  </p>
  <p>
    Welcher Arzt hat die größte Kompetenz? Wer hat die meiste Erfahrung? Wen
    finden Patienten klasse? Überlassen Sie BetterDoc die Suche nach dem
    bestmöglichen Arzt oder der passenden Klinik und erhöhen Sie damit Ihre
    Heilungschancen.
  </p>
  <p>
    <b>BetterDoc nutzt nur objektive Qualitätskriterien bei der Recherche:</b>
  </p>
  <collapsible>
    <template v-slot:title>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            :src="require('@lib/assets/icons/icon_diagnosespezifische.svg')"
            size="large"
          ></ion-icon>
        </ion-col>
        <ion-col>
          <b>Diagnosespezifische Patientenbefragungen</b>
        </ion-col>
      </ion-row>
    </template>
    <div class="ion-margin-bottom">
      Für viele Diagnosen erhebt BetterDoc Daten mittels spezifischer Fragebögen
      zur Indikations- und Ergebnisqualität über einen Zeitraum von bis zu 2
      Jahren. So erhält BetterDoc auch Informationen zur Patientenzufriedenheit
      mit den Prozessen vor Ort.
    </div>
  </collapsible>
  <collapsible>
    <template v-slot:title
      ><ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            :src="require('@lib/assets/icons/icon_fachliche.svg')"
            size="large"
          ></ion-icon>
        </ion-col>
        <ion-col>
          <b>Fachliche Empfehlungen des Experten-Beirats</b>
        </ion-col>
      </ion-row></template
    >
    <div class="ion-margin-bottom">
      Der Experten-Beirat von BetterDoc besteht aus über 2500 führenden
      deutschen Ärzten, die uns hochspezialisiert in komplexeren Situationen
      unterstützen, den richtigen Spezialisten/Klinik zu identifizieren.
    </div>
  </collapsible>
  <collapsible>
    <template v-slot:title
      ><ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            :src="require('@lib/assets/icons/icon_gesetzliche.svg')"
            size="large"
          ></ion-icon>
        </ion-col>
        <ion-col>
          <b>Gesetzliche Qualitätssicherung</b>
        </ion-col>
      </ion-row></template
    >
    <div class="ion-margin-bottom">
      Für bestimmte Leistungsbereiche fließen ausgewählte Daten aus den
      Qualitätsberichten der Kliniken in unsere Empfehlungslogik mit ein.
    </div>
  </collapsible>
  <collapsible>
    <template v-slot:title
      ><ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            :src="require('@lib/assets/icons/icon_fallzahlen.svg')"
            size="large"
          ></ion-icon>
        </ion-col>
        <ion-col>
          <b>Fallzahlen von Diagnosen/Prozeduren</b>
        </ion-col>
      </ion-row></template
    >
    <div class="ion-margin-bottom">
      Fallzahlen können bei vielen Erkrankungen einen wichtigen Hinweis auf eine
      vorhandene Spezialisierung geben.
    </div>
  </collapsible>
  <collapsible>
    <template v-slot:title
      ><ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            :src="require('@lib/assets/icons/icon_zertifikate.svg')"
            size="large"
          ></ion-icon>
        </ion-col>
        <ion-col>
          <b>Zertifikate</b>
        </ion-col>
      </ion-row></template
    >
    <div class="ion-margin-bottom">
      Zertifikate fließen ebenfalls in die Bewertung der Ärzte mit ein. Hierbei
      prüft und bewertet BetterDoc sehr genau die fachlichen Anforderungen, auf
      deren Basis das jeweilige Zertifikat an Ärzte oder Kliniken vergeben wird.
    </div>
  </collapsible>
  <div class="ion-margin-bottom"></div>
  <!-- <ion-button
    v-if="['contact', 'chat'].includes(from)"
    size="small"
    fill="clear"
    class="ion-text-wrap ion-no-padding ion-margin-top"
    @click="openKostenerstattungModal"
    >Kostenlos für ARAG-Kunden mit Vollversicherung!&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button> -->
</template>

<script>
import {
  modalController,
  // IonButton,
  IonIcon,
  IonRow,
  IonCol,
} from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@arag/components/KostenerstattungBetterDocModal";
import Header from "@/components/Header";
import Collapsible from "@/components/Collapsible";

export default {
  emits: ["open-chat"],
  components: {
    // IonButton,
    IonIcon,
    Header,
    IonRow,
    IonCol,
    Collapsible,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
